import React from 'react';
import PropTypes from 'prop-types';

import {LOADING_TEMPLATE, NODATA_TEMPLATE, userShape} from '../utils';

import LoadingTemplate from './LoadingTemplate';
import NoDataTemplate from './NoDataTemplate';
import StyledAvatar from './StyledAvatar';

const Avatar = ({user = null, showPresence = false, showInfo = false, showTitle = true}) => {
	const props = {
		personQuery: user?.email ?? '',
		personCardInteraction: showInfo && user?.isInternal === true ? 'hover' : 'none',
		showPresence
	};

	if (showTitle === false) props.className = 'no-title';

	return (
		<StyledAvatar {...props}>
			<LoadingTemplate template={LOADING_TEMPLATE} />
			<NoDataTemplate template={NODATA_TEMPLATE} user={user} />
		</StyledAvatar>
	);
};

Avatar.propTypes = {
	user: PropTypes.shape(userShape),
	showInfo: PropTypes.bool,
	showPresence: PropTypes.bool,
	showTitle: PropTypes.bool
};

export default Avatar;
